import { ExportOutlined } from "@ant-design/icons";
import { Typography } from "antd";
import React from "react";
import { Link } from "react-router-dom";

export const CustomTextField = ({
  value = "",
  prefix,
  copyable = false,
  onEmpty = "n/a",
  link = "",
  newPage = false,
  style,
}: {
  value?: string | String | null | number;
  prefix?: any;
  copyable?: boolean;
  onEmpty?: "none" | "n/a";
  link?: string;
  newPage?: boolean;
  style?: React.CSSProperties;
}) => {
  return (
    <div style={{ display: "flex" }}>
      {link && !newPage ? (
        <Typography.Link href={link}>{value}</Typography.Link>
      ) : (
        <Typography.Text style={style}>
          {prefix}{" "}
          {value ? (
            value
          ) : (
            <Typography.Text type="secondary">{onEmpty}</Typography.Text>
          )}
        </Typography.Text>
      )}
      {copyable && (
        <Typography.Text copyable={{ text: (value || "").toString() }} />
      )}
      {link && newPage && (
        <Link to={link} target="blank">
          {" "}
          <ExportOutlined />
        </Link>
      )}
    </div>
  );
};
